import { Colors } from '~/themes/colors';

export const ShareIcon = ({ size = 24, color = Colors.secondary_500 }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M16 7L9 10L16 7Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M9 12L16 15L9 12Z" fill={color} />
    <path d="M16 7L9 10M9 12L16 15" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 7C8.2088 7 10 8.7912 10 11C10 13.2096 8.2088 15 6 15C3.7912 15 2 13.2096 2 11C2 8.7912 3.7912 7 6 7Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 2C19.2088 2 21 3.7912 21 6C21 8.2096 19.2088 10 17 10C14.7912 10 13 8.2096 13 6C13 3.7912 14.7912 2 17 2Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 13C19.2088 13 21 14.7912 21 17C21 19.2096 19.2088 21 17 21C14.7912 21 13 19.2096 13 17C13 14.7912 14.7912 13 17 13Z"
      fill={color}
    />
  </svg>
);
